import { skipToken } from "@tanstack/react-query";

import { api } from "~/utils/api";

export const useHomeownerSentimentScore = (organizationId: string | undefined, canViewDetails: boolean) => {
  return api.person.getHomeownerSentimentScore.useQuery(organizationId ? { organizationId } : skipToken, {
    enabled: canViewDetails,
  });
};
